(ns hypnos.dme.tile.field.referral-pressure
  "Fields for pressure (CPAP or IPAP & EPAP)."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Fields

(defn cpap-field
  ([state]
   (cpap-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (when (= :modality/cpap
            (get-in @state [:patient :patient/last-consult :consult/modality :value]))
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/pressure)]]
      [:div.field-body
       [:div.field.is-narrow
        [:div.field.has-addons
         [:div.control
          [:a.button.is-static (tr :ui.label/cpap)]]
         [:div.control
          [:div.select.is-fullwidth
           [:select
            {:value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/cpap :value])]
                          val
                          "unknown")
             :disabled  disabled
             :on-change (fn [e]
                          (let [val       (-> e .-target .-value)
                                old-value (get-in @state [:patient :patient/last-consult :consult/cpap :value])
                                new-value (when-not (= "unknown" val) (int val))
                                changed?  (or (get-in @state [:patient :patient/last-consult :consult/cpap :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/cpap :value]
                                   new-value)
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/cpap :dirty?]
                                   changed?)))
             :on-focus  (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/last-consult :consult/cpap :touched?]
                                 true))}
            [:option {:key 0 :value "unknown"} (tr :ui.label/unsure)]
            (doall
             (for [n (range 3 31)]
               [:option {:key n :value n} (str n)]))]]]
         [:div.control
          [:a.button.is-static (tr :ui.label/cmH20)]]]]]])))

(defn ipap+epap-field
  ([state]
   (ipap+epap-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (when (= :modality/bipap-vpap
            (get-in @state [:patient :patient/last-consult :consult/modality :value]))
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/pressure)]]
      [:div.field-body
       [:div.field.is-narrow
        [:div.field.has-addons
         [:div.control
          [:a.button.is-static (tr :ui.label/ipap)]]
         [:div.control
          [:div.select.is-fullwidth
           [:select
            {:disabled  disabled
             :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/ipap :value])]
                          val
                          "unknown")
             :on-change (fn [e]
                          (let [val       (-> e .-target .-value)
                                old-value (get-in @state [:patient :patient/last-consult :consult/ipap :value])
                                new-value (when-not (= "unknown" val) (int val))
                                changed?  (or (get-in @state [:patient :patient/last-consult :consult/ipap :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/ipap :value]
                                   new-value)
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/ipap :dirty?]
                                   changed?)))
             :on-focus  (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/last-consult :consult/ipap :touched?]
                                 true))}
            [:option {:key 0 :value "unknown"} (tr :ui.label/unsure)]
            (doall
             (for [n (range 3 31)]
               [:option {:key (str n) :value n} (str n)]))]]]
         [:div.control
          [:a.button.is-static (tr :ui.label/cmH20)]]]]
       [:div.field.is-narrow
        [:div.field.has-addons
         [:div.control
          [:a.button.is-static (tr :ui.label/epap)]]
         [:div.control
          [:div.select.is-fullwidth
           [:select
            {:disabled  disabled
             :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/epap :value])]
                          val
                          "unknown")
             :on-change (fn [e]
                          (let [val       (-> e .-target .-value)
                                old-value (get-in @state [:patient :patient/last-consult :consult/epap :value])
                                new-value (when-not (= "unknown" val) (int val))
                                changed?  (or (get-in @state [:patient :patient/last-consult :consult/epap :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/epap :value]
                                   new-value)
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/epap :dirty?]
                                   changed?)))
             :on-focus  (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/last-consult :consult/epap :touched?]
                                 true))}
            [:option {:key 0 :value "unknown"} (tr :ui.label/unsure)]
            (doall
             (for [n (range 3 31)]
               [:option {:key (str n) :value n} (str n)]))]]]
         [:div.control
          [:a.button.is-static (tr :ui.label/cmH20)]]]]]])))
